import type { Currency, Label, RelationLink, UserType } from '@/types';

export const enum Direction {
    FROM = 'from',
    TO = 'to',
}

export enum PaymentType {
    WALLET = 'wallet'
}

interface QuoteAmount {
    amount: string;
    currencyCode: Currency;
}

export interface RequestQuote {
    currencyCodeFrom: Currency;
    currencyCodeTo: Currency;
    requestedAmount: QuoteAmount;
    requestedAmountType: Direction;
    userType: UserType;
}

export interface RequestBuyCryptoQuote extends RequestQuote {
    paymentMethod?: string;
    promoCode?: string | null;
}

export interface RequestSellCryptoQuote extends RequestQuote {
    payoutMethod?: string;
    paymentType?: PaymentType | null;
    promoCode?: string | null;
    address?: string | null;
    sendAll?: boolean;
}

export interface RequestSwapCryptoQuote extends RequestQuote {
    payoutMethod?: string;
    paymentType?: PaymentType | null;
    payoutType?: PaymentType | null;
    promoCode?: string | null;
    address?: string | null;
    sendAll?: boolean;
}

interface Fees {
    networkFee: QuoteAmount;
    serviceFee: QuoteAmount;
    blockchainFee?: QuoteAmount;
    totalFee: QuoteAmount;
    feeDiscount?: QuoteAmount;
}

interface Commissions {
    our: QuoteAmount;
    from: QuoteAmount;
    to: QuoteAmount;
}

interface ExchangeRate {
    from: string,
    to: string,
    rate: string,
}

export interface PayMethodQuote {
    id: string;
    name: string;
    amountFrom: QuoteAmount;
    amountTo: QuoteAmount;
    amountToEquivalent: QuoteAmount | null;
    amountFromEquivalent: QuoteAmount | null;
    fees: Fees;
    feesInCrypto: Fees;
    commissions: Commissions;
    exchangeRateCryptoToFiat: ExchangeRate | null;
    expiresAt: string;
}

export interface PaymentMethodError {
    error: {
        code: string;
        message: string
    };
    paymentMethod: string;
}

export interface PayoutMethodError {
    error: {
        code: string
        message: string
    };
    payoutMethod: string;
}

interface PromoCode {
    error: {
        code: string
        message: string
    };
}

interface QuoteBase {
    id: string;
    currencyCodeFrom: Currency | string;
    currencyCodeTo: Currency | string;
    requestedAmount: QuoteAmount;
    requestedAmountType: Direction;
    promoCode?: PromoCode;
}

export interface BuyCryptoQuote extends QuoteBase {
    paymentMethods: PayMethodQuote[];
    paymentMethodErrors?: PaymentMethodError[];
}

export interface SellCryptoQuote extends QuoteBase {
    payoutMethods: PayMethodQuote[];
    payoutMethodErrors?: PayoutMethodError[];
}

export interface SwapCryptoQuote {
    id: string;
    name: string;
    amountFrom: QuoteAmount;
    amountTo: QuoteAmount;
    fees: Fees;
    feesInCrypto: Fees;
    expiresAt: string;
    link: RelationLink;
    labels: Label[];
    icon: string;
    exchangeRateCryptoToFiat: ExchangeRate | null;
    payoutMethodErrors?: PayoutMethodError[];
}
